module.exports = __webpack_public_path__ + "static/media/your-AV-guy.85c5a5c4.jpg";